import { render, staticRenderFns } from "./Abdomen.vue?vue&type=template&id=dd4bb902&scoped=true"
import script from "./Abdomen.vue?vue&type=script&lang=js"
export * from "./Abdomen.vue?vue&type=script&lang=js"
import style0 from "./Abdomen.vue?vue&type=style&index=0&id=dd4bb902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4bb902",
  null
  
)

export default component.exports